import { Component } from '@angular/core';

@Component({
  selector: 'app-cards5-examples-29',
  templateUrl: './cards5-examples-29.component.html'
})
export class Cards5Examples29Component {}
